import React from 'react';

import {Link} from "react-router-dom";

import './Home.css';

import {ReactComponent as ExternalIcon} from "../../images/icons/external.svg";
import {ReactComponent as ArrowDownIcon} from "../../images/icons/arrow-down.svg";
import AboutImage from '../../images/image1.jpg';
import BlockForm from "../../components/BlockForm/BlockForm";
import {ReactComponent as MapsSmallImage} from "../../images/maps-small.svg";
import {ReactComponent as PhoneIcon} from "../../images/icons/phone.svg";
import API from "../../components/api";
import {SERVER_URL} from "../../config";
import Checkbox from "../../components/ui/checkbox/checkbox";
import Button from "../../components/ui/button/button";
import ModalComponent from "../../components/ui/modalComponent/modalComponent";
import Linkify from 'linkify-react'

class HomePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accordionTabActive: 0,

            isLoaded: false,

            data: {
                articles: [],
                banner: {},
                categories: [],
                employees: [],
                faq: [],
                vacancies: []
            },
            isCallModalOpen: false
        }

        this.openCallModal = () => {
            this.setState({isCallModalOpen: true})
        }

        this.sendCall = () => {
            API.postRequestCall(this.state.name, this.state.phone)
                .then(data => {
                    this.props.addSnackbar("Спасибо, мы перезвоним вам в ближайшее время", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.setState({isCallModalOpen: false})
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось отправить заявку", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.setAccordionTab = (index) => {
            if (this.state.accordionTabActive === index) {
                this.setState({accordionTabActive: null})

                this.state.data.faq.forEach((question, thisIndex) => {
                    const container = document.getElementById(`question-${thisIndex}`);
                    container.style.height = '0px';
                })
            } else {
                this.setState({accordionTabActive: index})

                this.state.data.faq.forEach((question, thisIndex) => {
                    if (thisIndex === index) {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = container.scrollHeight + (16 * 2) + 'px';
                    } else {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = '0px';
                    }
                })
            }
        }

        this.formatNumber = (number) => {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }

        this.formatPrice = (service) => {
            if (service.price_type === 'fix')
                return <div className="price">
                    <div className="from">{this.formatNumber(service.price_from)} ₽</div>
                </div>

            else if (service.price_type === 'from-to')
                return <div className="price">
                    <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                    <div className="to">до {this.formatNumber(service.price_to)} ₽</div>
                </div>

            else if (service.price_type === 'only-from')
                return <div className="price">
                    <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                </div>

            else if (service.price_type === 'free')
                return <div className="price">
                    <div className="from">Бесплатно</div>
                </div>

            return <div className="price">
                <div className="from">от {this.formatNumber(service.price_from)} ₽</div>
                <div className="to">до {this.formatNumber(service.price_to)} ₽</div>
            </div>
        }

        this.renderCategories = (data) => {
            const categories = data.categories;

            const countServices = (category) => {
                return category.services.length;
            };

            // Считаем количество услуг для каждой категории
            const categoriesWithCount = categories.map(cat => ({
                ...cat,
                serviceCount: countServices(cat)
            }));

            // Ищем середину по количеству услуг
            const totalServices = categoriesWithCount.reduce((sum, cat) => sum + cat.serviceCount, 0);
            let sum = 0;
            let middleIndex = 0;

            for (let i = 0; i < categoriesWithCount.length; i++) {
                sum += categoriesWithCount[i].serviceCount;
                if (sum >= Math.ceil(totalServices / 2)) {
                    middleIndex = i + 1; // +1 чтобы включить текущую категорию в первую половину
                    break;
                }
            }

            const firstHalf = categoriesWithCount.slice(0, middleIndex);
            const secondHalf = categoriesWithCount.slice(middleIndex);

            return (
                <>
                    <div className="wrap">
                        {firstHalf.map(category => (
                            <div className="category" key={category.id}>
                                <div className="header">{category.name}</div>
                                <div className="list">
                                    {category.services.map(service => (
                                        <div className="service" key={service.id}>
                                            <div className="label">{service.name}</div>
                                            {this.formatPrice(service)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="wrap">
                        {secondHalf.map(category => (
                            <div className="category" key={category.id}>
                                <div className="header">{category.name}</div>
                                <div className="list">
                                    {category.services.map(service => (
                                        <div className="service" key={service.id}>
                                            <div className="label">{service.name}</div>
                                            {this.formatPrice(service)}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            );
        }

        this.renderEmployees = (employees) => {
            return <>
                {
                    employees.map(employee => {
                        return <div className='employee' onClick={() => {
                                    setTimeout(() => {
                                        window.open('/docs/?ref=main', '_blank');
                                    }, 150)
                                }}>
                            <img src={SERVER_URL + employee.image} alt=''/>
                            <div className='info'>
                                <div className='job'>
                                    <div className='name'>
                                        {employee.name}
                                    </div>
                                    <div className='title'>
                                        {employee.description}
                                    </div>
                                    {
                                        employee.experience ? <div className='experience'>
                                            {employee.experience} лет опыта
                                        </div> : null
                                    }
                                </div>
                                {
                                    employee.url_type === 'prodoctorov' ?
                                        <a className='button' href={employee.url} target="_blank">
                                            Найти на «продокторов»
                                            <ExternalIcon/>
                                        </a> : (
                                            employee.url_type === 'other' ?
                                                <a className='button' href={employee.url} target="_blank">
                                                    Перейти
                                                    <ExternalIcon/>
                                                </a> : null
                                        )
                                }
                            </div>
                        </div>
                    })
                }
            </>
        }
    }

    componentDidMount() {
        API.getMainPage()
            .then(data => {
                this.setState({
                    data: data,
                    isLoaded: true
                })
            })
            .catch(() => {
            })
    }

    render() {
        const {data} = this.state;

        return <div className='home'>
            <div className='mobile-header'>
                <div className='header'>
                    <div className='top'>
                        <div className='address-container'>
                            <div className='maps-container'>
                                <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                                   target='_blank'>
                                    <MapsSmallImage/>
                                </a>
                            </div>
                            <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                               target='_blank' className='headline_16_20'>
                                Омск, пр-т Комарова 21 к2,
                                <br/>помещение 2П
                            </a>
                        </div>
                        <div className='contacts-container'>
                            <div className='contacts-info'>
                                <PhoneIcon/>
                                <div className='phone-numbers'>
                                    <a className='headline_18_22 button' href='tel:+79059225522'>
                                        +7 905 922 55 22
                                    </a>
                                    <a className='paragraph_14_20 button' href='tel:+7(3812)956010'>
                                        или +7 (3812) 95 60 10
                                    </a>
                                </div>
                            </div>
                            <div className='button' onClick={this.openCallModal}>
                                Заказать звонок
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalComponent customClass="call-modal"
                            isOpen={this.state.isCallModalOpen}
                            onClose={() => this.setState({isCallModalOpen: false})}>
                <div className='call-modal-entry'>
                    <div className='title'>
                        Перезвоним вам в&nbsp;течение дня
                    </div>
                    <div className='inputs'>
                        <input placeholder='Ваше имя' value={this.state.name}
                               onChange={(e) => this.setState({name: e.target.value})}/>
                        <input placeholder='Номер телефона' value={this.state.phone}
                               onChange={(e) => this.setState({phone: e.target.value})}/>
                    </div>
                    <div className='consent'>
                        <Checkbox
                            checked={this.state.isChecked}
                            onChange={(checked) => this.setState({isChecked: checked})}
                        />
                        <div className='text'>
                            Я подтверждаю свое согласие на обработку
                            и хранение персональных данных
                        </div>
                    </div>
                    <div className='buttons row'>
                        <Button type='accent' size='large' fullWidth onClick={this.sendCall}
                                disabled={!this.state.isChecked}>
                            Записаться на приём
                        </Button>
                    </div>
                </div>
            </ModalComponent>
            {
                this.state.isLoaded ? <>
                    <div className='block-1'>
                        <div className='banner' style={{
                            background: `url(${SERVER_URL + data.banner.image}) no-repeat center center`,
                            backgroundSize: 'cover'
                        }}>
                            <div className='title headline_48_52'>
                                {data.banner.title}
                            </div>
                            <div className='button' onClick={() => {
                                window.open(data.banner.button_link, '_blank')
                            }}>
                                {data.banner.button_text}
                            </div>
                        </div>
                        <div className='articles'>
                            <div className='header'>
                                <div className='title headline_30_36'>
                                    Статьи
                                </div>
                                <Link className='button action_16_24' to='/articles/'>
                                    Читать все
                                </Link>
                            </div>
                            <div className='entry'>
                                {
                                    data.articles.map(article => {
                                        return <Link className='article' to={`/articles/${article.id}/`}>
                                            <img src={SERVER_URL + article.image} alt=''/>
                                            <div className='info'>
                                                <div className='header'>
                                                    <div className='title'>
                                                        {article.title}
                                                    </div>
                                                    <div className='sub-title'>
                                                        {article.subtitle}
                                                    </div>
                                                </div>
                                                <div className='date'>
                                                    {article.published_date}
                                                </div>
                                            </div>
                                        </Link>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className='block-2'>
                        <div className='header'>
                            <div className='title'>
                                Популярные услуги
                            </div>
                            <Link className='button' to='/services/'>
                                Список всех услуг
                            </Link>
                        </div>
                        <div className="catalog">
                            {
                                this.renderCategories(data)
                            }
                        </div>
                    </div>
                    <div className='block-3'>
                        <div className='header'>
                            <div className='title'>
                                Сотрудники
                            </div>
                            <Link className='button' to='/employees/'>
                                Наши сотрудники
                            </Link>
                        </div>
                        <div className='employees'>
                            {this.renderEmployees(data.employees)}
                        </div>
                    </div>
                    <div className='block-4'>
                        <div className='container'>
                            <div className='title'>
                                О нас
                            </div>
                            <div className='description'>
                                Клиника «ЭСТЭЙ» работает в Омске с 2015 года. Мы оказываем основные виды
                                стоматологической
                                помощи в одной клинике — от лечения и хирургии до имплантации и ортопедии.
                            </div>
                            <Link className='button' to='/about/'>
                                Больше про ЭСТЭЙ
                            </Link>
                        </div>
                        <img src={AboutImage} alt=''/>
                    </div>
                    {
                        data.vacancies.length > 0 ? <div className='block-5'>
                            <div className='header'>
                                <div className='title'>
                                    Вакансии
                                </div>
                                <Link className='button' to='/employees/'>
                                    Все вакансии
                                </Link>
                            </div>
                            <div className='list'>
                                {
                                    data.vacancies.map(vacancy => {
                                        return <div className='card'>
                                            <div className='title'>
                                                {vacancy.name}
                                            </div>
                                            <a className='button' href={vacancy.url} target='_blank'>
                                                Перейти к вакансии
                                                <ExternalIcon/>
                                            </a>
                                        </div>
                                    })
                                }
                            </div>
                        </div> : null
                    }
                    <div className='block-6'>
                        <div className='header'>
                            Частые вопросы
                        </div>
                        <div className='column'>
                            <div className='questions'>
                                {this.state.data.faq.map((question, index) => {
                                    const classList = ['question']

                                    if (this.state.accordionTabActive === index) classList.push('active')

                                    return <div key={index} className={classList.join(' ')}
                                                onClick={() => this.setAccordionTab(index)}>
                                        <div className='head'>
                                            <div className='arrow'>
                                                <ArrowDownIcon/>
                                            </div>
                                            <div className='title'>{question.question}</div>
                                        </div>
                                        <div id={`question-${index}`} className='description'>
                                            <Linkify
                                                options={{
                                                    target: '_blank',
                                                    rel: 'noopener noreferrer',
                                                    className: 'faq-link'
                                                }}
                                            >
                                                {question.answer}
                                            </Linkify>
                                        </div>
                                    </div>
                                })}
                            </div>
                            <Link className='button' to='/faq/'>
                                Здесь нет ответа на мой вопрос
                            </Link>
                        </div>
                    </div>
                    <BlockForm addSnackbar={this.props.addSnackbar}/>
                </> : null
            }
        </div>
    }
}


export default HomePage;
